export interface IBorderRadius {
  normal: string;
  message: string;
}

export const borderRadius: IBorderRadius = {
  normal: "4px",
  message: "12px",
};
